import "@accessible360/accessible-slick";

export const PXSlider = (function() {
	'use strict';

    let $sliders;
	
	function init() {
		
		$sliders = $(".pxblock--slider .slides");

        $sliders.each(function () {
			initSlider( $(this) );
        });
		
		events();
	}

	

    function initSlider($slider) {
        $slider.slick({
			arrows: false,
            autoplay: true,
            autoplaySpeed: 7000,
			dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            pauseOnHover: false,
        });
    }

	function events() {}

	return {
		init: init
	};
})();
